module.exports = __webpack_public_path__ + "assets/img/investmentAssistant-advantage-icon.20f82c57.png";